import { downloadLink } from '@/lib/utils.js'
import ResourceIcon from '@/components/svgs/resource_icon.js'
export default function CompanyResourcesTable({downloads}) {
   let  categories = downloads?.reduce((groups, item) => {
    const group = (groups[item.category_name] || []); 
    group.push(item); 
    groups[item.category_name] =  group; 
    return groups;
  }, {})
  categories = categories || {} ;
  return (
    <section className="lexcms-resources-listings">
      {Object.keys(categories).sort().map((cat, i) => {
        return (
          <div className="lexcms-resources-category" key={i}>
            <h3 className="lexcms-resources-category-name">{cat}</h3>
            <ul>
              {categories[cat]?.map((d, i) => { 
                return (
                  <li key={i}>
                    <div className="lexcms-resources-download-link">
                      <ResourceIcon /> 
                      <a href={downloadLink(d)} target='_blank'>
                        {d.name}
                      </a>
                    </div>
                  </li>
                )
              })
              }
            </ul>
          </div>
        )
      })
      }
    </section>
  )
}
